// Allows you to pass props component that will be rendered by Route
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getUser } from "../helpers";
export const RouteWithProps = ({ props, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={
      matchProps =>
        getUser() ? (
          <Component {...matchProps} {...props} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )

      // <Component {...matchProps} {...props} />
    }
  />
);
